export const DEFAULT_PROJECT_NAME = 'Default';

export const ALL_WHITELIST_BLOCKCHAINS_VALUE = '*';
